import Vue from 'vue'
import Router from 'vue-router'
import {userLoggedIn} from '@/services/user';
import Projects from '@/components/Projects';
import ProjectDetail from '@/components/ProjectDetail';
import UserDetail from '@/components/UserDetail';
import Login from '@/components/Login';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/projects',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/me',
      name: 'UserDetail',
      component: UserDetail
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      meta: {requiresAuth: true}
    },
    {
      path: '/projects/:id',
      name: 'ProjectDetail',
      component: ProjectDetail,
      meta: {requiresAuth: true}
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(it => it.meta.requiresAuth) && !userLoggedIn()) {
    next({name: 'Login'})
  } else {
    next()
  }
})

export default router
